import { useQuery } from '@tanstack/react-query';

import { fetchRecording } from 'apis/hcp/recording.api';
import { Recording } from 'types/hcp/recording.type';

const transformResponse = (response: { data: { recording: Recording } }) => {
  return response.data.recording;
};

const useGetRecording = (id: string) => {
  const {
    data: recording,
    isPending,
    error,
  } = useQuery({
    queryKey: ['recording', id],
    queryFn: ({ signal }) => fetchRecording(id, signal),
    select: transformResponse,
    enabled: !!id,
  });

  return { recording, isPending, error };
};

export default useGetRecording;
